import { withSuspense } from '@/ui/utils/withSuspense'

import { ActivitySkeleton } from './components/skeleton/ActivitySkeleton'
import ActivityView from './views/ActivityView'

import { useActivity } from './logic/useActivity'
import { GuestView } from '@/ui/organisms/guest-view/GuestView'

function ActivityContainer() {
  const { activities, activityStats, isLoading, guestMode, openConnectModal } = useActivity()

  if (guestMode) {
    return <GuestView openConnectModal={openConnectModal} />
  }

  return (
    <>{isLoading ? <ActivitySkeleton /> : <ActivityView activities={activities} activityStats={activityStats} />}</>
  )
}

const ActivityContainerWithSuspense = withSuspense(ActivityContainer, ActivitySkeleton)
export { ActivityContainerWithSuspense as ActivityContainer }
